import React from 'react';

const MagazineListSkeleton: React.FC = () => {
    return (
        <div className="space-y-3">
            {/* 매거진 아이템 스켈레톤 */}
            {Array.from({ length: 5 }).map((_, index) => (
                <div key={index} className="animate-pulse">
                    <div className="bg-white border border-gray-200 rounded-lg p-3">
                        <div className="flex items-start justify-between">
                            <div className="flex-1">
                                {/* NEW 뱃지 스켈레톤 (랜덤하게 표시) */}
                                {index % 3 === 0 && (
                                    <div className="absolute -top-1 -left-2 w-2 h-2 bg-gray-300 rounded-full mb-2"></div>
                                )}
                                
                                {/* 제목 스켈레톤 */}
                                <div className="h-5 bg-gray-300 rounded w-3/4 mb-2"></div>
                                
                                {/* 내용 스켈레톤 */}
                                <div className="space-y-1 mb-3">
                                    <div className="h-3 bg-gray-300 rounded w-full"></div>
                                    <div className="h-3 bg-gray-300 rounded w-2/3"></div>
                                </div>
                                
                                {/* 통계 정보 스켈레톤 */}
                                <div className="flex items-center gap-4">
                                    {/* 좋아요 아이콘과 숫자 */}
                                    <div className="flex items-center gap-1">
                                        <div className="h-4 w-4 bg-gray-300 rounded"></div>
                                        <div className="h-3 bg-gray-300 rounded w-8"></div>
                                    </div>
                                    
                                    {/* 댓글 아이콘과 숫자 */}
                                    <div className="flex items-center gap-1">
                                        <div className="h-4 w-4 bg-gray-300 rounded"></div>
                                        <div className="h-3 bg-gray-300 rounded w-8"></div>
                                    </div>
                                    
                                    {/* 날짜 */}
                                    <div className="h-3 bg-gray-300 rounded w-16"></div>
                                </div>
                            </div>
                            
                            {/* 화살표 아이콘 스켈레톤 */}
                            <div className="ml-4 flex-shrink-0">
                                <div className="h-5 w-5 bg-gray-300 rounded"></div>
                            </div>
                        </div>
                    </div>
                </div>
            ))}
        </div>
    );
};

export default MagazineListSkeleton;
